/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
/* eslint-disable react/no-did-update-set-state, css-modules/no-undef-class, camelcase, css-modules/no-unused-class */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { intlShape, FormattedMessage, defineMessages } from 'react-intl';
import moment from 'moment';
import cx from 'classnames';
import { connect } from 'react-redux';

import { clearBooking } from '../../actions/booking';
import history from '../../history';
// import mp from '../../analytic';
import s from './Search.css';
import iconMap from './icon-map.webp';
import iconMapAdd2x from './icon-map@2x.webp';
import LoadingIndicator from '../../components/LoadingIndicator';

import BookingEngineSmall from '../../components/BookingEngineSmall';
import HotelCard from '../../components/HotelCard';
import SearchCarouselImages from './SearchCarouselImages';

import { onTrackingPageView } from '../../lib/fbpixel';
import Leaflet from '../../components/LeafletMap';

import gtm from '../../lib/gtm';

const messages = defineMessages({
  map: {
    id: 'hotel_destination.map',
    defaultMessage: '##Map##',
    description: 'Sticky Map button',
  },
  close: {
    id: 'common.close',
    defaultMessage: '##Close##',
    description: 'Close button',
  },
});

const navAndHeroHeight = 560;
const bookingEngineHeightDesktop = 260;
const bookingEngineHeightMobile = 345;
const minBookingEngineTopOffset = 80;
const maxMobileWidth = 992;
let self = null;

class Search extends React.Component {
  static propTypes = {
    locations: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
      }),
    ),
    clearBooking: PropTypes.func,
    doSearch: PropTypes.func,
    query: PropTypes.shape({
      country: PropTypes.string,
      city: PropTypes.string,
      check_in: PropTypes.string,
      check_out: PropTypes.string,
      rooms: PropTypes.string,
      adults: PropTypes.string,
      children: PropTypes.string,
    }).isRequired,
  };

  static contextTypes = {
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    locations: [],
    clearBooking: () => {},
    doSearch: () => {},
    query: {
      rooms: 1,
      adults: 2,
      children: 1,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      firedMixpanel: false,
      selectImage: 0,
      windowHeight: 0,
      isMobileDevice: false,
      mapPositionFix: false,
      hoverHotel: null,
      mapHeight: '100vh',
      cityName: '',
      hotels: [],
      areaImages: [],
      isClickedGallery: false,
      showMap: false,
      locations: props.locations,
      country: props.query.country,
      city: props.query.city,
      checkIn: moment(props.query.check_in),
      checkOut: moment(props.query.check_out),
    };
    self = this;
  }

  componentDidMount() {
    this.initializeData();
    if (process.env.BROWSER) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'booking_funnel',
        step: 'hotel_list',
      });
      this.onWindowResize();
      onTrackingPageView(self.props.query.country, window.App.facebookPixelId);
    }
    this.bindWindowResize = this.onWindowResize.bind(this);
    this.bindWindowScroll = this.onWindowScroll.bind(this);
    window.addEventListener('resize', this.bindWindowResize);
    window.addEventListener('scroll', this.bindWindowScroll);
    const setInitialPos = () => {
      if (self.map && self.map.offsetTop > 0) {
        self.initialMapPosition.y = self.map.offsetTop;
        self.initialMapPosition.x = self.map.offsetLeft;
        self.initialMapWidth = self.map.offsetWidth;
        self.initialized = true;
        self.bindWindowResize();
      } else {
        setTimeout(setInitialPos, 300);
      }
    };
    setTimeout(setInitialPos, 300);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.initializeData();
    if (nextProps.query.check_in && nextProps.query.check_out) {
      this.setState({
        checkIn: moment(nextProps.query.check_in),
        checkOut: moment(nextProps.query.check_out),
      });
    }
  }

  componentDidUpdate() {
    this.updateHeight();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.bindWindowResize);
    window.removeEventListener('scroll', this.bindWindowScroll);
    if (this.timeoutPromise) {
      clearTimeout(this.timeoutPromise);
    }
  }

  onWindowResize = () => {
    if (
      this.hotelList &&
      this.hotelList.offsetWidth > 0 &&
      this.hotelList.offsetLeft > 0
    ) {
      setTimeout(() => {
        self.initialMapPosition.x =
          self.hotelList.offsetWidth + self.hotelList.offsetLeft;
        if (self.container.offsetWidth > 992) {
          self.initialMapWidth = self.container.offsetWidth * 0.5;
        } else if (self.container.offsetWidth > 1160) {
          self.initialMapWidth = self.container.offsetWidth * 0.5;
        } else if (self.container.offsetWidth > 1243) {
          self.initialMapWidth = self.container.offsetWidth * 0.5;
        }
        self.setState({
          windowHeight: window.innerHeight,
          isMobileDevice: window.innerWidth < maxMobileWidth,
        });
      }, 500);
    } else {
      setTimeout(() => {
        this.setState({
          windowHeight: window.innerHeight,
          isMobileDevice: window.innerWidth < maxMobileWidth,
          mapHeight:
            this.hotelList && this.hotelList.offsetHeight < window.innerHeight
              ? this.hotelList.offsetHeight
              : window.innerHeight,
        });
      }, 500);
    }
  };

  onWindowScroll = () => {
    if (!this.state.isMobileDevice) {
      if (typeof window !== 'undefined') {
        if (this.initialized && this.initialMapPosition.y < window.scrollY) {
          if (!this.state.mapPositionFix) {
            this.setState({ mapPositionFix: true });
          }
          return;
        }
      }
    }
    if (this.state.mapPositionFix) {
      this.setState({ mapPositionFix: false });
    }
  };

  onMouseOverHotelCard = hotel => {
    this.setState({ hoverHotel: hotel });
  };

  onMouseOutHotelCard = () => {
    this.setState({ hoverHotel: null });
  };

  onClickHotelBookNow = hotel => {
    const bodyElement = document.querySelector('body');
    bodyElement.style.height = 'auto';
    bodyElement.style.overflowY = 'auto';
    let {
      query: { rooms, adults, children },
    } = this.props;
    const checkIn = moment(hotel.check_in);
    const checkOut = moment(hotel.check_out);
    if (!rooms) {
      rooms = 1;
    }
    if (!adults) {
      adults = 2;
    }
    if (!children) {
      children = 0;
    }
    this.props.clearBooking();
    setTimeout(() => {
      history.push({
        pathname: `/${this.context.intl.locale}/booking/room-select/`,
        search: `hotel=${hotel.id}&check_in=${checkIn.format(
          'YYYY-MM-DD',
        )}&check_out=${checkOut.format(
          'YYYY-MM-DD',
        )}&rooms=${rooms}&adults=${adults}&children=${children}`,
      });
    });
  };

  onClickStickyMapButton = () => {
    const showMap = !this.state.showMap;
    const bodyElement = document.querySelector('body');
    this.setState({ showMap });
    if (showMap) {
      // Disable page scroll to prevent content behind the map to be scrolled
      bodyElement.style.height = '100vH';
      bodyElement.style.overflowY = 'hidden';
    } else {
      // Re-enable page scroll
      bodyElement.style.height = 'initial';
      bodyElement.style.overflowY = 'initial';
    }
  };

  onSearch = async (country, city, checkIn, checkOut) => {
    if (
      self.state.country === country &&
      self.state.city === city &&
      self.state.checkIn.isSame(checkIn) &&
      self.state.checkOut.isSame(checkOut)
    ) {
      return;
    }
    self.setState({
      hotels: [],
    });
    self.render();
    const {
      query: { rooms, adults, children },
    } = self.props;
    let countryAndCity = '';
    if (country) {
      countryAndCity += `country=${country}&`;
    }
    if (city) {
      countryAndCity += `city=${city}&`;
    }
    const data = await self.props.doSearch({
      check_in: checkIn.format('YYYY-MM-DD'),
      check_out: checkOut.format('YYYY-MM-DD'),
    });
    self.setState({
      city,
      country,
      checkIn,
      checkOut,
      locations: data.locations,
    });
    setTimeout(self.initializeData, 10);
    const path = `/${
      self.context.intl.locale
    }/search/?${countryAndCity}check_in=${checkIn.format(
      'YYYY-MM-DD',
    )}&check_out=${checkOut.format(
      'YYYY-MM-DD',
    )}&rooms=${rooms}&adults=${adults}&children=${children}`;
    window.history.pushState({ path }, '', path);
  };

  initializeData = () => {
    const { city, country, locations } = this.state;
    let cityName = '';
    let nameEnglish = '';
    const hotels = [];
    let areaImages = [];
    if (locations) {
      locations.forEach(lcountry => {
        if (lcountry.id === parseInt(country, 10) || !country) {
          if (!country) {
            areaImages.push({
              image: lcountry.image_path,
              name: '',
            });
          }
          if (lcountry.id === parseInt(country, 10)) {
            areaImages = lcountry.images.map(image => ({
              image,
              name: lcountry.name,
            }));
            cityName = lcountry.name;
            nameEnglish = lcountry.name_en;
          }
          lcountry.children.forEach(lcity => {
            if (city) {
              if (lcity.id === parseInt(city, 10)) {
                areaImages = [
                  {
                    image: lcity.image_path,
                    name: lcity.name,
                  },
                ];
                cityName = lcity.name;
                nameEnglish = lcity.name_en;
                lcity.children.forEach(area => {
                  if (area.hotels !== null) {
                    hotels.push(...area.hotels);
                  }
                });
              }
            } else {
              lcity.children.forEach(area => {
                if (area.hotels !== null) {
                  hotels.push(...area.hotels);
                }
              });
            }
          });
        }
      });
      if (!country && !city) {
        cityName = 'Red Planet Hotels';
        nameEnglish = 'All Hotels';
      }
      // if (!this.state.firedMixpanel && process.env.BROWSER) {
      //   // mp.track('#Destination Page', { destination: nameEnglish });
      //   this.setState({ firedMixpanel: true });
      // }
    } else {
      setTimeout(this.initializeData, 300);
    }
    this.setState({
      cityName,
      hotels,
      areaImages,
    });
  };

  updateHeight = () => {
    if (process.env.BROWSER) {
      const newHeight =
        this.hotelList.offsetHeight < window.innerHeight
          ? this.hotelList.offsetHeight
          : window.innerHeight;
      if (newHeight !== this.state.mapHeight) {
        this.setState({
          mapHeight: newHeight,
        });
      }
    }
  };

  bindWindowResize = null;

  bindWindowScroll = null;

  initialMapPosition = { x: 0, y: 0 };

  initialMapWidth = 0;

  initialized = false;

  timeoutPromise = null;

  render() {
    const {
      windowHeight,
      isMobileDevice,
      mapPositionFix,
      hoverHotel,
      mapHeight,
      showMap,
      locations,
    } = this.state;
    const mapWidth = isMobileDevice
      ? '100%'
      : mapPositionFix && this.initialMapWidth;
    let mapDisplay = 'block';
    if (isMobileDevice && !showMap) {
      mapDisplay = 'none';
    }
    const mapStyle = {
      display: mapDisplay,
      height: isMobileDevice ? '100vh' : mapHeight,
      left: mapPositionFix ? this.initialMapPosition.x : 0,
    };
    if (mapWidth) {
      mapStyle.width = mapWidth;
    }
    const bookingEngineHeight = !isMobileDevice
      ? bookingEngineHeightDesktop
      : bookingEngineHeightMobile;
    let topOfBookingEngine =
      bookingEngineHeight - (windowHeight - navAndHeroHeight);
    if (topOfBookingEngine < minBookingEngineTopOffset) {
      topOfBookingEngine = minBookingEngineTopOffset;
    }
    const {
      query: { country, city, rooms, adults, children },
    } = this.props;
    const { checkIn, checkOut, cityName, hotels, areaImages } = this.state;
    return (
      <div className={s.root}>
        <script
          src="https://onboard.triptease.io/bootstrap.js?integrationId=01EA1KCH8D2QHV5S5CHPKQTCAT"
          defer
          async
          crossOrigin="anonymous"
          type="text/javascript"
        />
        <SearchCarouselImages cityName={cityName} areaImages={areaImages} />
        <BookingEngineSmall
          locations={locations}
          selectedCountry={parseInt(country, 10)}
          selectedCity={parseInt(city, 10)}
          checkIn={checkIn}
          checkOut={checkOut}
          isMobileDevice={isMobileDevice}
          onUpdatedSearch={this.onSearch}
        />
        <div
          ref={container => {
            this.container = container;
          }}
          className={s.container}
        >
          <div
            ref={hotelList => {
              this.hotelList = hotelList;
            }}
            className={s.hotelList}
          >
            {hotels.length === 0 && (
              <div className={s.loadingIndicator}>
                <LoadingIndicator color="#E2231A" />
              </div>
            )}
            <ul>
              {hotels.length > 0 &&
                hotels.map(hotel => (
                  <li key={hotels.indexOf(hotel)}>
                    <HotelCard
                      hotel={hotel}
                      checkIn={checkIn}
                      checkOut={checkOut}
                      numberOfRooms={parseInt(rooms, 10)}
                      adults={parseInt(adults, 10)}
                      children={parseInt(children, 10)} // eslint-disable-line  react/no-children-prop
                      onMouseOver={this.onMouseOverHotelCard}
                      onMouseOut={this.onMouseOutHotelCard}
                      onClickBookNow={this.onClickHotelBookNow}
                    />
                  </li>
                ))}
            </ul>
          </div>
          <div
            ref={map => {
              this.map = map;
            }}
            className={cx(s.map, mapPositionFix && s.fixedMap)}
            style={{ ...mapStyle }}
          >
            {isMobileDevice && (
              <button
                className={s.buttonCloseMap}
                onClick={this.onClickStickyMapButton}
              >
                <FormattedMessage {...messages.close} />
              </button>
            )}
            {process.env.BROWSER && (
              <Leaflet hotels={hotels} hoveringHotel={hoverHotel} />
            )}
          </div>
        </div>
        {isMobileDevice && (
          <button
            className={s.buttonStickyButton}
            onClick={this.onClickStickyMapButton}
          >
            <img src={iconMap} srcSet={`${iconMapAdd2x} 2x`} alt="map" /> |
            <FormattedMessage {...messages.map} />
          </button>
        )}
      </div>
    );
  }
}

const mapDispatch = {
  clearBooking,
};

export default connect(null, mapDispatch)(withStyles(s)(Search));
